// extracted by mini-css-extract-plugin
export default {"VerifiedIcon":"MarketplaceItem-module__VerifiedIcon--Kc36J","Label":"MarketplaceItem-module__Label--gDK4T"};